// removed by extract-text-webpack-plugin
module.exports = {"addevent":"_27BnrqHrxyCKlFx2qkOjgF","text":"_3JDvqVmSP8m8tG1p8pw6Dz","transparent":"_2zNkkTDKTCIObnB99iZ5m9","addeventCategory":"_3Z-PGyfnH84lLGr7dlHvHf","criarWrap":"_33BPoS1Vec-fOHygoa3_Yw","criar":"_2dj-2KB55onMSTUkm4luZi","eventitem":"_1iUw2TygTmObpCSMkJOgfV","type":"_1-VlIM8gLg5ro6tXsicM7_","event":"_1frf79CdtkeqFSYfJ4Zco","title":"_1yscYGXxPkbXt7IbadBwtC","date":"_2XoDx9O6JnnL8rO73_Utnb","eventdayhour":"_1ulylqXZRWtDifp3RJQhRu","boxProgress":"_1YTvanvNlZnoF9tV6X2LZO"};


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/CreateEvent/Create/style.css
// module id = 412
// module chunks = 39